<div class="patients-list-wrapper">
  <div id="header-wrapper">
    <div class="d-flex w-100">
      <msd-search-bar (searchEvent)="updateSearchQuery($event)"></msd-search-bar>
      <div class="dropdown ml10px" dropdown container="body">
        <button id="sort-button" type="button" class="btn btn-outline btn-outline-primary text-icon" dropdownToggle>
          <i i-bs name="arrow-down-up" width="20" height="20"></i>
          <span id="sort-label">Tri&nbsp;:&nbsp;</span>
          <span id="sort-name-label">{{ getSortText() }}</span>
        </button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li role="menuitem" (click)="updatePatientsDefaultSort('createdAt')"><span class="dropdown-item sorter">Date de création (desc.)</span>
          <li role="menuitem" (click)="updatePatientsDefaultSort('updatedAt')"><span class="dropdown-item sorter">Date de dernière modification (desc.)</span>
          <li role="menuitem" (click)="updatePatientsDefaultSort('lastActiveDate')"><span class="dropdown-item sorter">Date de dernière activité (desc.)</span>
        </ul>
      </div>
    </div>
    <div id="actions-wrapper">
      <div class="dropdown" dropdown container="body" placement="right">
        <button
          id="more-actions-button"
          type="button"
          dropdownToggle
          class="btn btn-outline btn-outline-primary text-icon"
        >
          <ng-container *ngIf="actionsButtonHasPending else actionsButton">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="ml10px">Opération en cours...</span>
          </ng-container>
          <ng-template #actionsButton>
            <span>Actions groupées</span>
            <i i-bs name="three-dots" width="20" height="20"></i>
          </ng-template>
        </button>
        <div class="dropdown-backdrop fade"></div>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" style="top: 22px;" role="menu">
          <li
            (click)="onSendMessage()"
            [class.disabled]="!checkedAll && !indeterminate"
            role="menuitem">
            <span class="dropdown-item"
                  [class.disabled]="!checkedAll && !indeterminate">Envoyer un message {{ targetName() }}</span>
          </li>
          <li
            (click)="onSendEncouragement()"
            *ngIf="!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived"
            [class.disabled]="!checkedAll && !indeterminate"
            role="menuitem">
            <span class="dropdown-item"
                  [class.disabled]="!checkedAll && !indeterminate">Envoyer un encouragement {{ targetName() }}</span>
          </li>
          <li
            (click)="onSendDocument()"
            *ngIf="!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived"
            [class.disabled]="!checkedAll && !indeterminate"
            id="global-action-send-document"
            role="menuitem">
            <span class="dropdown-item"
                  [class.disabled]="!checkedAll && !indeterminate">Envoyer un document  {{ targetName() }}</span>
          </li>
          <li
            (click)="onSendSurvey()"
            *ngIf="!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived"
            [class.disabled]="!checkedAll && !indeterminate"
            role="menuitem">
            <span class="dropdown-item"
                  [class.disabled]="!checkedAll && !indeterminate">Envoyer un questionnaire  {{ targetName() }}</span>
          </li>
          <li class="divider dropdown-divider"></li>
          <li
            (click)="onGroupedAll()"
            *ngIf="(!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived)"
            [class.disabled]="!indeterminate"
            role="menuitem">
            <span class="dropdown-item" [class.disabled]="!indeterminate">Grouper {{ targetNameAdmin() }}</span>
          </li>
          <li
            (click)="onUngroupedAll()"
            *ngIf="(!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived)"
            [class.disabled]="!indeterminate"
            role="menuitem">
            <span class="dropdown-item" [class.disabled]="!indeterminate">Dégrouper {{ targetNameAdmin() }}</span>
          </li>
          <li
            *ngIf="(!questionsService.selectedSortListType || questionsService.selectedSortListType !== SortListType.Archived)"
            role="menuitem"
            [class.disabled]="!indeterminate"
            (click)="onArchivedAll()">
            <span class="dropdown-item" [class.disabled]="!indeterminate">Archiver {{ targetNameAdmin() }}</span>
          </li>
          <li
            *ngIf="questionsService.selectedSortListType && questionsService.selectedSortListType === SortListType.Archived"
            role="menuitem"
            [class.disabled]="!indeterminate"
            (click)="onActivateAll()">
            <span class="dropdown-item"
                  [class.disabled]="!indeterminate">Activer {{ targetNameAdmin() }}</span>
          </li>
          <li class="divider dropdown-divider"></li>
          <li role="menuitem">
            <span id="cancel-link" class="dropdown-item action">Annuler</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="append-loader" *ngIf="isAppendLoading">
    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <span class="ml10px">Chargement...</span>
  </div>

  <table class="table header">
    <thead>
    <tr>
      <th id="patient-check-all">
        <input (ngModelChange)="onCheckAll($event)"
               [(ngModel)]="checkedAll"
               [indeterminate]="indeterminate"
               class="form-check-input"
               type="checkbox">
      </th>
      <th scope="col">Nom du patient</th>
      <th *ngIf="questionsService.selectedSortListType !== SortListType.Archived" id="group" scope="col">Groupe</th>
      <th *ngIf="!dietitian || dietitian.patientsDefaultSort === 'updatedAt'" id="updated-at" scope="col">Date dern.
        modif.
      </th>
      <th *ngIf="dietitian && dietitian.patientsDefaultSort === 'createdAt'" id="created-at" scope="col">Date création
      </th>
      <th *ngIf="dietitian && dietitian.patientsDefaultSort === 'lastActiveDate'" id="last-activity" scope="col">Date
        dern. activité
      </th>
      <th id="application" scope="col">Application</th>
      <th id="actions" scope="col">Actions</th>
    </tr>
    </thead>
  </table>
  <div (scrolled)="onScroll()" [scrollWindow]="false" id="patients-list-wrapper"
       infiniteScroll>
    <!-- <label>Tous les patients</label> -->
    <ng-container
      *ngIf="
        !isOnError && !isLoading && patientsList && patientsList.length > 0;
        else innerLoading
      "
    >
      <table class="table body">
        <tbody>
        <tr
          (onActivate)="onActivatePatient(patient.entity.id.toString())"
          (onAddToGroup)="onAddPatientToGroup(patient.entity)"
          (onRemoveToGroup)="onRemovePatientToGroup(patient.entity)"
          (onArchive)="onArchivePatient(patient.entity.id.toString())"
          (onClick)="goToPatient(patient.entity.id.toString())"
          (onEncouragement)="onSendEncouragement(patient.entity)"
          (onSendDocument)="sendDocumentToPatient(patient.entity)"
          (onSendMessage)="onSendMessage(patient.entity)"
          (onSendQuiz)="onSendSurvey(patient.entity)"
          *ngFor="let patient of patientsList"
          [(checked)]="patient.checked"
          [appInstalled]="patient.entity.isAppInstalled"
          [archivedAt]="patient.entity.archivedAt"
          [avatarUrl]="patient.entity.avatarUrl"
          [checkAll]="checkedAll"
          [checkable]="true"
          [createAt]="patient.entity.createdAt ? getMomentDate(patient.entity.createdAt) : undefined"
          [updateAt]="patient.entity.updatedAt ? getMomentDate(patient.entity.updatedAt) : undefined"
          [lastSeen]="
              patient.entity.lastActiveDate
                ? getMomentDate(patient.entity.lastActiveDate)
                : undefined
            "
          [groups]="getGroupsLabel(patient.entity)"
          [displayGroups]="questionsService.selectedSortListType !== SortListType.Archived"
          [initials]="patient.entity.initials"
          [isActionLoading]="patientPerformingAction === patient.entity.id.toString()"
          [title]="patient.entity.fullName"
          [sort]="dietitian?.patientsDefaultSort"
          msd-patient-cell
        ></tr>
        </tbody>
      </table>
    </ng-container>
    <ng-template #innerLoading>
      <ngx-inner-loading
        class="flex-center"
        [empty]="patientsList?.length === 0"
        [error]="isOnError"
        [loading]="isLoading"
        (retry)="loadPage(0)"
        [loadingDescription]="'Chargement...'"
        [emptyDescription]="
          dietitian && dietitian.patientCount > 0
            ? 'Aucun patient'
            : 'Vous n\'avez pas encore de patients enregistrés : ajoutez vos premiers patients sur l\'interface et invitez-les à utiliser l\'application !'
        "
        [errorDescription]="
          'Une erreur est survenue. Veuillez réessayer plus tard.'
        "
        [retryButtonText]="'Réessayer'"
      >
      </ngx-inner-loading>
    </ng-template>
  </div>
</div>
